export const locale = {
    lang: 'en',
    data: {
        REASSIGN_EMAIL: {
            FORM: {
                PROJECT: 'Project',
            },
            NOTIFICATIONS: {
                LOADING: 'Loading mails...',
                SAVING: 'Assigning mails...',
                WAIT: 'Please wait.',
                SUCCESS: 'Mails assigned successfully',
                ERROR: 'Error while assigning: ',
            },
            COLUMNS: {
                TITLE: 'Title',
                SUBJECT: 'Subject',
                TEXT: 'Message',
                TO: 'To',
                FROM: 'From',
                ATTACHMENTS: 'Attachments',
            },
            SAVE: 'Reassign E-Mails',
            FOLDER: 'Select Folder',
            TITLE: 'Reassign E-Mails',
        },
    },
};
